<template>
    <v-navigation-drawer expand-on-hover rail>
      <v-list>
        <v-list-item
          prepend-avatar="https://randomuser.me/api/portraits/men/17.jpg"
          title="Steinbach"
          subtitle="Engineering Lead">
        </v-list-item>
      </v-list>
      <v-divider/>
      <v-list density="compact" nav>

        <v-list-item @click="selectTab('page-item-database')"
          prepend-icon="mdi-database"
          title="Item Database"
          value="item-database">
        </v-list-item>

        <v-list-item @click="selectTab('page-world-items')"
          prepend-icon="mdi-earth"
          title="World Items"
          value="world-items">
        </v-list-item>

        <v-list-item @click="selectTab('page-servers')"
          prepend-icon="mdi-office-building"
          title="Servers"
          value="servers">
        </v-list-item>

        <v-list-item @click="selectTab('page-players')"
          prepend-icon="mdi-account-multiple"
          title="Players"
          value="players">
        </v-list-item>

        <v-list-item @click="selectTab('page-audit')"
          prepend-icon="mdi-cctv"
          title="Audit"
          value="audit">
        </v-list-item>
      </v-list>

    </v-navigation-drawer>
</template>

<script>
export default {
  name: 'SideBar',
  provide() {
    return {
      tab: this.selectedTab
    }
  },
  data: () => ({
    selectedTab: 'page-world-items'
  }),
  methods: {
    selectTab(newTab) {
        this.$emit('select-tab', newTab);
        console.log("selecting tab:" + newTab);
        this.selectedTab = newTab;
    }
  }
};

</script>